const initialState = {
	vets: null,
	loading: false,
	error: null
}

const vets = (state = initialState, action) => {
	switch (action.type) {
		case 'RESET_APP':
			return { ...initialState }
		case 'CLEAR_VETS':
			return { ...state, vets: null, loading: false, error: null }
		case 'GET_VETS':
			return { ...state, loading: true, error: null }
		case 'GET_VETS_SUCCESS':
			return { ...state, vets: action.payload, loading: false, error: null }
		case 'GET_VETS_FAIL':
			return { ...state, loading: false, error: action.payload }
		default:
			return state
	}
}

export default vets
